import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledHdModal = styled(Modal)(() => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  overflow: 'auto',
  zIndex: 'var(--zindex-modal)',
  '& .primary': {
    width: '500px',
    maxWidth: '100%'
  },
  '&.top-align': {
    alignItems: 'flex-start',
    '& .dialog-content': {
      width: '512px',
      marginTop: '120px'
    }
  },
  '&.center-align': {
    '& .dialog-content': {
      margin: 'auto'
    }
  }
}));
